import { LazyPage, PipelineDestinationLayoutPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { destinationRouteParams } from '@/services/router/pipeline-route-params';

function PipelineDestinationLayoutRoute() {
  return (
    <LazyPage>
      <PipelineDestinationLayoutPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId')({
  params: destinationRouteParams,
  component: PipelineDestinationLayoutRoute,
});
